import {
  signInWithPopup,
  GoogleAuthProvider,
  OAuthProvider,
} from "firebase/auth";
import { authentication } from "../../firebase";
import GoogleButton from "../../components/GoogleButton";
import EmailButton from "../../components/EmailButton";
import EmailLogin from "../../components/EmailLogin";
import "./SigninScreen.css";
import { useState, useEffect } from "react";
import MicrosoftButton from "../../components/MicrosoftButton";
import { CircularProgress } from "@mui/material";
import CleverButton from "../../components/CleverButton";

const cleverClientID = "81c607e331c7da3c5547";
const redirect_uri = window.location.href.split(/#\?/)[0];


const AuthMethods = ({ setShowEmail, setAuthenticating, setLoginFailure }) => {
  async function GoogleAuth() {
    setAuthenticating(true);
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({
      //   // Force re-consent.
      prompt: "select_account",
    });
    signInWithPopup(authentication, provider)
      .then((result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        GoogleAuthProvider.credentialFromResult(result);
      })
      .catch((error) => {
        // TODO: handle errors
      });
    setAuthenticating(false);
  }

  const MicrosoftAuth = (setLoginFailure) => {
    setAuthenticating(true);
    const microProvider = new OAuthProvider("microsoft.com");
    microProvider.setCustomParameters({
      prompt: "select_account",
    });
    signInWithPopup(authentication, microProvider)
      .then(() => {
        // TODO: do something on success?
      })
      .catch((error) => {
        if (error.code === "auth/account-exists-with-different-credential") {
          setLoginFailure(true);
        }
      });
    setAuthenticating(false);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <button
        className="providerButton"
        onClick={() => {
          setAuthenticating(true);
          GoogleAuth();
        }}
        style={{ marginTop: "8vh" }}
      >
        <GoogleButton />
      </button>
      <button
        className="providerButton"
        onClick={() => MicrosoftAuth(setLoginFailure)}
      >
        <MicrosoftButton />
      </button>
      <button
        className="providerButton"
        onClick={() => {
          window.location.href = `https://clever.com/oauth/authorize?response_type=code&redirect_uri=${redirect_uri}&client_id=${cleverClientID}`;
        }}
      >
        <CleverButton />
      </button>
      <button
        onClick={() => setShowEmail(true)}
        className="providerButton"
        style={{ marginBottom: 0 }}
      >
        <EmailButton />
      </button>
    </div>
  );
};

const AuthIndicator = () => {
  return (
    <div
      id="progress"
      style={{
        height: "100vh",
        width: "100vw",
        position: "fixed",
        top: "1px",
        background: "rgba(0,0,0,0.5)",
        zIndex: "100",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress style={{ height: "60px", width: "60px" }} />
    </div>
  );
};

export const Footer = () => {
  return (
    <>
      <div style={{ marginTop: "5vh" }} className="patentpending">
        Patent Pending
      </div>
      <div className="growthwell">© Growthwell LLC 2024</div>
      <div style={{ display: "flex", gap: "20px" }}>
        <div>
          <a
            href="https://drewschwartz.com/privacy-policy"
            className="growthwell"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
        </div>
        <div>
          <a
            href="https://drewschwartz.com/terms-of-service"
            className="growthwell"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Service
          </a>
        </div>
      </div>
      <img
        className="bottomdesign"
        src="../images/overlaping colors.png"
        alt="design"
        loading="lazy"
      ></img>
    </>
  );
};

const SigninScreen = ({ cleverAuthCode }) => {
  const [showEmail, setShowEmail] = useState(false);
  const [loginFailure, setLoginFailure] = useState(false);
  const [authenticating, setAuthenticating] = useState(false);

  useEffect(() => {
    if (cleverAuthCode) {
      console.log(true);
    }
  }, [cleverAuthCode]);

  return (
    <div className="outer">
      <img
        className="logo"
        src="../images/123WellnessLogo-01.png"
        alt="123 Wellness Logo"
        loading="lazy"
      ></img>
      <div className="signin">
        {loginFailure
          ? "Looks like either your email or password is incorrect. " +
            "Try again or login with a different provider."
          : "Sign in to continue your wellness journey"}
      </div>
      {(authenticating || cleverAuthCode) && <AuthIndicator />}
      {showEmail ? (
        <EmailLogin
          hideLogin={setShowEmail}
          setAuthenticating={setAuthenticating}
        />
      ) : (
        <AuthMethods
          setShowEmail={setShowEmail}
          setLoginFailure={setLoginFailure}
          setAuthenticating={setAuthenticating}
        />
      )}
      <Footer />
    </div>
  );
};
export default SigninScreen;
